
const DEFAULT_CONFIG = {
    //标题
    APP_NAME: process.env.VUE_APP_TITLE,

    //首页地址
    DASHBOARD_URL: "/index",

    //版本号
    APP_VER: "1.0.0",

    //内核版本号
    CORE_VER: "1.0.0",

    SOCKET: false,
    // SOCKET: false,

    //接口地址
    API_URL: process.env.NODE_ENV === 'development' && process.env.VUE_APP_PROXY === 'true' ? "/api" : process.env.VUE_APP_API_ROOT,

    //请求超时
    TIMEOUT: 120 * 1000,

    //TokenName
    TOKEN_NAME: "token",

    //Token前缀，注意最后有个空格，如不需要需设置空字符串
    TOKEN_PREFIX: "",

    //追加其他头
    HEADERS: {},

    //请求是否开启缓存
    REQUEST_CACHE: false,

    //布局 默认：default | 通栏：header | 经典：menu | 功能坞：dock
    //dock将关闭标签和面包屑栏
    LAYOUT: 'default',

    //菜单是否折叠
    MENU_IS_COLLAPSE: false,

    //菜单是否启用手风琴效果
    MENU_UNIQUE_OPENED: false,

    //是否开启多标签
    LAYOUT_TAGS: true,

    //语言
    LANG: 'zh-cn',

    // 数据储存前缀
    DATA_PREFIX: 'cmyiotuser',

    //主题颜色
    COLOR: '',

    //是否加密localStorage, 为空不加密，可填写AES(模式ECB,移位Pkcs7)加密
    LS_ENCRYPTION: '',

    //localStorageAES加密秘钥，位数建议填写8的倍数
    LS_ENCRYPTION_key: '2XFXGDGF8XFXGDKF6XFXGDKI',

    //控制台首页默认布局
    DEFAULT_GRID: {
        //默认分栏数量和宽度 例如 [24] [18,6] [8,8,8] [6,12,6]
        layout: [11, 13, 24],
        //小组件分布，com取值:views/home/components 文件名
        copmsList: [
            ['welcome', 'goods'],
            ['about', 'time', 'echarts']
        ]
    }
}

export default DEFAULT_CONFIG;


// WEBPACK FOOTER //
// ./src/config/index.js